import React from 'react';

import FormLogin from '../../forms/FormLogin';
import Page from '../../layout/Page';
import Card from '../../layout/Card';

const PageLogin = () => (
  <Page>
    <Card grid="sm">
      <FormLogin />
    </Card>
  </Page>
);

export default PageLogin;
